import pedidoVentaService from '../services/pedidoVentaService';
import { umDesdeDetalleTransaccion } from './umVentaDocumento';

/** Recupera la UM del detalle del pedido origen (transacción master). */
export async function umDesdePedidoMaster(
  nroFormularioMaster?: number | null,
  nroItemMaster?: number | null,
  codigoArticulo?: string,
): Promise<string> {
  const nfm = Number(nroFormularioMaster);
  if (!Number.isFinite(nfm) || nfm <= 0) return '';
  try {
    const pedido = await pedidoVentaService.getPedidoVenta(nfm);
    const detalles = pedido.detalles || [];
    const nim = Number(nroItemMaster);
    let line =
      Number.isFinite(nim) && nim > 0
        ? detalles.find((d) => Number(d.nroItem) === nim)
        : undefined;
    const cod = String(codigoArticulo ?? '').trim();
    if (!line && cod) {
      line = detalles.find((d) => String(d.codigoArticulo ?? '').trim() === cod);
    }
    return umDesdeDetalleTransaccion(line);
  } catch {
    return '';
  }
}
